import { HttpService } from '../../services/services.index';
import { EEndpoint } from '../../config/endpoint.config';
import { TBankKeys } from '../../domain/bank.interface';

const httpService = new HttpService();

export const BANK_PAYMENTS_RESUME_LOADED = 'BANK_PAYMENTS_RESUME_LOADED';
export const BANK_PENDING_PAYMENTS_LOADED = 'BANK_PENDING_PAYMENTS_LOADED';
export const BANK_SOCIAL_PROJECTS_LOADED = 'BANK_SOCIAL_PROJECTS_LOADED';
export const TPV_URL_LOADED = 'TPV_URL_LOADED';
export const LILI_BANK_LOADED = 'LILI_BANK_LOADED';
export const BANK_RESET = 'BANK_RESET';

export const loadBankPaymentsResume = () => {
  return (dispatch: any) => {
    httpService.get(EEndpoint.BANK_PAYMENTS_RESUME).then((res: any) => {
      dispatch({
        type: BANK_PAYMENTS_RESUME_LOADED,
        payload: res,
      });
    });
  };
};

export const loadBankPendingPayments = () => {
  return (dispatch: any) => {
    httpService.get(EEndpoint.BANK_PENDING_PAYMENTS).then((res: any) => {
      dispatch({
        type: BANK_PENDING_PAYMENTS_LOADED,
        payload: res,
      });
    });
  };
};

export const loadBankSocialProjects = () => {
  return (dispatch: any) => {
    httpService.get(EEndpoint.BANK_SOCIAL_PROJECTS).then((res: any) => {
      dispatch({
        type: BANK_SOCIAL_PROJECTS_LOADED,
        payload: res,
      });
    });
  };
};

export const loadLiliSocialBank = () => {
  return (dispatch: any) => {
    httpService.get(EEndpoint.LILI_BANK).then((res: any) => {
      dispatch({
        type: LILI_BANK_LOADED,
        payload: res,
      });
    });
  };
};

export const resetBank = (key: TBankKeys) => {
  return (dispatch: any) => {
    dispatch({
      type: BANK_RESET,
      payload: key,
    });
  };
};
